import { axiosInstance } from "../services/utilities";
import axios from "axios";
export var api = async function ({ method = "get", url, body, status = false, token = '' }, config = {}) {
    return await new Promise((resolve, reject) => {
        axiosInstance.defaults.headers.common['authorization'] = getToken() ? getToken() : ''
        axiosInstance[method](api, (body ? body : ""), config).then((data) => {
            resolve(statusHelper(status, data))
        }).catch((error) => {
            if (error) {
                if (error.response) {
                    reject(statusHelper(status, error.response))

                } else {
                    reject(error)
                }
            } else {
                reject(false)
            }
        })
    })
};
export const getToken = () => {
    return localStorage.getItem('token');
};
export const makeRequest = async (methodType, url, payload = {}, status = false) => {
    const userToken = localStorage.getItem('userToken');
    // if (!userToken || !userToken.trim()) {
    //     window.location.href = '/login';
    // }
    const headers = {
        "x-auth-header": userToken ? userToken.trim() : ''
    };
    const config = {
        headers,
        crossdomain: true
    };
    try {
        let response;
        const method = methodType.toLowerCase();
        if (method === 'get' || method === 'delete') {
            response = await axios[method](url, config);
        } else {
            response = await axios[method](url, payload, config);
        }
        return statusHelper(status, response);
    } catch (error) {
        if (error?.response) {
            throw statusHelper(status, error.response);
        } else {
            throw error || false;
        }
    }
};
export const makeRequestLogin = async (methodType, url, payload = {}, status = false) => {
    const userToken = localStorage.getItem('userToken');
    const headers = {
        "x-auth-header": userToken ? userToken.trim() : ''
    };
    const config = {
        headers,
        crossdomain: true
    };
    try {
        let response;
        const method = methodType.toLowerCase();
        if (method === 'get' || method === 'delete') {
            response = await axios[method](url, config);
        } else {
            response = await axios[method](url, payload, config);
        }
        return statusHelper(status, response);
    } catch (error) {
        if (error?.response) {
            throw statusHelper(status, error.response);
        } else {
            throw error || false;
        }
    }
};
export const makeRequestRegister = async (methodType, url, payload = {}, status = false) => {
    try {
        let response;
        const method = methodType.toLowerCase();
        if (method === 'get' || method === 'delete') {
            response = await axios[method](url);
        } else {
            response = await axios[method](url, payload);
        }
        return statusHelper(status, response);
    } catch (error) {
        if (error?.response) {
            throw statusHelper(status, error.response);
        } else {
            throw error || false;
        }
    }
};
var statusHelper = (status, data) => {
    if (data.status === 401) {
        window.location.href = process.env.REACT_APP_FRONTEND_SERVICE_1 + '/refresh-token'
    }
    if (status) {
        return {
            status: data.status,
            response: data.data
        }
    } else {
        return data.data
    }
}